import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {StringUtil} from "../../../util/string.util";
import {FormControl} from "@angular/forms";
import {Subscription} from "rxjs";
import {ValidationService} from "../../../util/service/validation/validation-service";
import {MatSelect} from "@angular/material/select";

@Component({
  selector: 'app-frontend-dropdown',
  standalone: false,
  templateUrl: './frontend-dropdown.component.html',
  styleUrls: ['./frontend-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FrontendDropdownComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  dropDownControl = new FormControl();
  disableSelect = new FormControl(false);
  searchInput?: any;
  @Input()
  value?: any;
  @Input()
  title?: string;
  @Input()
  required?: string | boolean;
  @Input()
  disabled: boolean = false;
  @Input()
  isSearchable?: boolean = true;
  @Input()
  isMultiple: boolean = false;
  @Input()
  autoSelectLatest?: boolean = false;
  @Input()
  displayKey?: string;
  @Input()
  searchOnKey?: string;
  @Input()
  selectedSearchKey?: any;
  @Input()
  options: any = [];
  @Input()
  selectedOptions: any = [];
  @Input()
  fieldName?: string;
  @Output()
  onSelected: EventEmitter<any> = new EventEmitter();
  @Output()
  searchChange: EventEmitter<string | null> = new EventEmitter();
  @Output()
  valueChange: EventEmitter<any> = new EventEmitter();
  @Output()
  selectedSearchKeyChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('select') select!: MatSelect;
  private subscription?: Subscription;

  constructor(injector: Injector, private validationService: ValidationService) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.disableSelect.valueChanges.subscribe(disabled => {
      if (disabled) {
        this.dropDownControl.disable();
      } else {
        this.dropDownControl.enable();
      }
    });
    this.subscription = this.validationService.validate$.subscribe(() => {
      this.checkValidity();
    });
    let keys: any = [];
    if (this.displayKey) {
      for (let i = 0; i < this.displayKey!.split(',').length; i++) {
        keys.push(this.displayKey!.split(',')[i]);
      }
    }
    if (this.selectedOptions) {
      this.selectedOptions = this.selectedOptions.filter((selectedOption: any) => {
        return selectedOption !== undefined && selectedOption !== null && selectedOption[this.fieldName!] !== undefined && selectedOption[this.fieldName!] !== null;
      });
    } else {
      this.selectedOptions = [];
    }
    if (!this.options || this.options.length === 0) {
      this.options = this.selectedOptions;
    }
    this.refreshCustom();
    if (this.autoSelectLatest && this.options && this.options.length > 0 && (!this.selectedOptions || this.selectedOptions.length === 0)) {
      this.selectedOptions = [this.options[0]];
      this.onSelected.emit(this.options[0]);
      this.refreshCustom();
    }
    if (this.isSearchable) {
      this.selectedSearchKey = this.getSearchOnKey()[0];
      this.selectedSearchKeyChange.emit(this.selectedSearchKey);
    }
  }

  ngOnChanges(changes: any) {
    if (changes.selectedOptions && !changes.selectedOptions.firstChange) {
      this.refreshCustom();
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  checkValidity() {
    const isInvalid = this.required && (this.isMultiple ? (this.value === undefined || this.value === null || this.value.length === 0) : (this.value === undefined || this.value === null || (typeof this.value === 'string' ? this.value.trim() === '' : isNaN(this.value))));
    const isValid = !isInvalid;
    this.dropDownControl.markAsTouched();
    this.dropDownControl.setErrors(isValid ? null : {required: true});
    this.validationService.updateValidationStatus(isValid);
  }

  refreshCustom() {
    if (this.disabled) {
      this.disableSelect.setValue(true);
    } else {
      this.disableSelect.setValue(false);
    }
    let keys: any = [];
    if (this.displayKey) {
      for (let i = 0; i < this.displayKey!.split(',').length; i++) {
        keys.push(this.displayKey!.split(',')[i]);
      }
    }
    for (let i = 0; i < this.options.length; i++) {
      this.options[i].Custom = this.injectCustomVariable(this.options[i], keys);
    }
    for (let i = 0; i < this.selectedOptions.length; i++) {
      this.selectedOptions[i].Custom = this.injectCustomVariable(this.selectedOptions[i], keys);
    }
    setTimeout(() => {
      if (this.fieldName) {
        if (this.isMultiple) {
          this.value = this.selectedOptions.map((selectedOption: any) => {
            return selectedOption[this.fieldName!];
          });
          this.valueChange.emit(this.value);
        } else {
          if (this.selectedOptions.length > 0) {
            this.value = this.selectedOptions[0][this.fieldName];
            this.valueChange.emit(this.value);
          }
        }
      }
    }, 200);
    this.updateDropDownControl();
  }

  injectCustomVariable(option: any, keys: any[]): string {
    let customs: any = [];
    for (let j = 0; j < keys.length; j++) {
      if (keys[j].includes('.')) {
        let temp = option[keys[j].split('.')[0]];
        for (let k = 1; k < keys[j].split('.').length; k++) {
          temp = temp[keys[j].split('.')[k]];
        }
        customs.push(temp);
      } else {
        customs.push(option[keys[j]]);
      }
    }
    return customs.map((item: any, index: number) => index === 0 ? item : `(${item})`).join(' ');
  }

  onQuerySubmitted(event?: any) {
    if (event) {
      this.searchChange.emit(StringUtil.reformatString(event.target.value));
    }
  }

  onItemSelected(index: number) {
    if (this.isMultiple) {
      let indexOfSelected = this.selectedOptions.findIndex((selectedOption: any) => {
        return this.options[index][this.fieldName!] === selectedOption[this.fieldName!];
      });
      if (indexOfSelected === -1) {
        this.selectedOptions.push(this.options[index]);
      } else {
        this.selectedOptions.splice(indexOfSelected, 1);
      }
      if (this.fieldName) {
        this.value = this.selectedOptions.map((selectedOption: any) => {
          return selectedOption[this.fieldName!];
        });
        this.valueChange.emit(this.value);
      }
      this.onSelected.emit(this.selectedOptions);
    } else {
      this.selectedOptions = [this.options[index]];
      if (this.fieldName) {
        this.value = this.selectedOptions[0][this.fieldName];
        this.valueChange.emit(this.value);
      }
      this.onSelected.emit(this.selectedOptions[0]);
    }
    this.searchInput = '';
    this.updateDropDownControl();
  }

  getSelectedLabels(): string {
    if (this.selectedOptions && this.selectedOptions.length > 0) {
      return this.selectedOptions.map((option: any) => {
        return option && option.Custom;
      }).join(', ');
    } else {
      return this.title!;
    }
  }

  onSelectedItemRemoveClicked(index: number) {
    this.selectedOptions.splice(index, 1);
    if (this.isMultiple) {
      if (this.fieldName) {
        this.value = this.selectedOptions.map((selectedOption: any) => selectedOption[this.fieldName!]);
        this.valueChange.emit(this.value);
      }
      this.onSelected.emit(this.selectedOptions);
    } else {
      this.value = null;
      this.valueChange.emit(this.value);
      this.onSelected.emit(this.selectedOptions.length > 0 ? this.selectedOptions[0] : null);
    }
    this.updateDropDownControl();
  }

  updateDropDownControl() {
    if (this.isMultiple) {
      this.dropDownControl.setValue(this.selectedOptions.map((option: any) => option[this.fieldName!]));
    } else {
      this.dropDownControl.setValue(this.selectedOptions.length > 0 ? this.selectedOptions[0][this.fieldName!] : null);
    }
  }

  hasSelected(option: any): boolean {
    if (this.selectedOptions) {
      return this.selectedOptions.some((selectedOption: any) => {
        return selectedOption[this.fieldName!] === option[this.fieldName!];
      });
    }
    return false;
  }

  getSearchOnKey(): any[] {
    if (this.searchOnKey) {
      return this.searchOnKey!.split(',');
    }
    return [];
  }

  onSearchKeyClicked(searchKey: string) {
    this.selectedSearchKey = searchKey;
    this.selectedSearchKeyChange.emit(this.selectedSearchKey);
    this.searchChange.emit(this.searchInput);
  }

  getSearchKeyLabel(searchKey: string): string {
    return searchKey.split('.')[searchKey.split('.').length - 1];
  }

  onSelectionChange(event: any): void {
    if (this.select) {
      this.select.close();
      setTimeout(() => {
        (document.activeElement as HTMLElement).blur();
      }, 0);
    }
  }
}
